'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
  'use strict';

  angular.module('msGoals').component('msGoalCard', {
    bindings: {
      goalData: '<'
    },
    templateUrl: 'goals/templates/goal-card.html',
    controller: GoalCardController
  });

  GoalCardController.$inject = ['NotifyingSvc', 'goalSvc', '$filter', '$log', '$timeout', '$scope', '$sessionStorage', '$translate'];

  function GoalCardController(NotifyingSvc, goalSvc, $filter, $log, $timeout, $scope, $sessionStorage, $translate) {
    var vm = this;
    vm.$onInit = init;
    vm.openEditGoalModal = openEditGoalModal;
    vm.openEditHabitsModal = openEditHabitsModal;
    vm.triggerHabit = triggerHabit;
    vm.getCompletedDate = getCompletedDate;
    vm.getCompletedTime = getCompletedTime;
    vm.getHabitLabel = getHabitLabel;

    // Make a copy, so the msTrackerChart component watches the changes in this controller,
    // not hte parent.

    function init() {
      vm.statsMode = false;
      vm.goalDataCopy = null;
      vm.timeouts = {};
      vm.unlockHabitTimer = {};
      vm.smallDelay = 1; // Delay (in minutes) that gives possibility to 'uncheck' habit completion;
      vm.bigDelay = 15; // Delay (in minutes) that blocks new habit completion;
      vm.monthTitle = moment().format('MMMM');
      initStoredGoalData(vm.goalData.id);
      initInputGoalData(angular.copy(vm.goalData));
    }

    vm.statsModeToggle = function () {
      if (vm.statsMode) {
        vm.isClosed = true;
        // 2000ms to let screen reader notice alert.
        $timeout(function () {
          return vm.isClosed = false;
        }, 2000);
      }
      vm.statsMode = !vm.statsMode;
    };

    function initInputGoalData(goal) {
      // Prevent the method for page refresh
      if ($sessionStorage['goal-' + goal.id]) {
        return;
      }

      // Create 'isBlocked' flag and start 'Unlock Habit' timer 
      // for habits that were completed during 'bigDelay' minutes.
      goal.sections.forEach(function (habit) {
        if (isCompletedRecently(habit, vm.bigDelay)) {
          habit.isBlocked = true;
          startUnlockHabitTimer(goal.id, habit);
        }
      });

      vm.goalDataCopy = goal;

      // Store processed Goal Data and Timeout  in storage
      $sessionStorage['goal-' + goal.id] = goal;
      $sessionStorage['goal-timeouts-' + goal.id] = vm.timeouts;
    }

    function initStoredGoalData(goalId) {
      // Prevent the method for regular init (come from 'Progress' tab)
      if (!$sessionStorage['goal-' + goalId]) {
        return;
      }

      // Update Goal Data and Timeouts from storage
      vm.goalDataCopy = $sessionStorage['goal-' + goalId];
      vm.timeouts = $sessionStorage['goal-timeouts-' + goalId];

      // Process stored data
      vm.goalDataCopy.sections.forEach(function (habit) {
        if (habit.isCompletedRecently) {
          // Start Submit timeout for habits
          // that were completed during 'smallDelay' minutes.
          if (vm.timeouts[habit.id].timeout) {
            startSubmitHabitTimer(habit, { datetime: moment(vm.timeouts[habit.id].data.datetime), value: 1 });
          }
        }
        // Start 'Unlock Habit' timer for habits that were completed during 'bigDelay' minutes.
        // 'isBlocked' flag was added before storing.
        if (habit.isBlocked && isCompletedRecently(habit, vm.bigDelay)) {
          startUnlockHabitTimer(goalId, habit);
        }
      });
    }

    $scope.$on('$destroy', function () {
      // Going out from 'Goals' page
      if (!angular.equals({}, vm.timeouts)) {
        // Send Submit request for all habits that were waiting for end of 'smallDelay'.
        Object.entries(vm.timeouts).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              value = _ref2[1];

          if (value.timeout) {
            triggerHabitRequest(value.habit, value.data, true);
          }
        });
      }
      if (!angular.equals({}, vm.unlockHabitTimer)) {
        // Prevent all 'Unlock Habit' timers
        Object.entries(vm.unlockHabitTimer).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
              key = _ref4[0];

          if (key && vm.unlockHabitTimer[key]) {
            $timeout.cancel(vm.unlockHabitTimer[key]);
            delete vm.unlockHabitTimer[key];
          }
        });
      }

      // Clear storage
      delete $sessionStorage['goal-' + vm.goalDataCopy.id];
      delete $sessionStorage['goal-timeouts-' + vm.goalDataCopy.id];
    });

    function triggerHabit(habit) {
      // Uncheck habit completion if it checked less then 'smallDelay' minutes ago.
      if (habit.isCompletedRecently) {
        removeCompletedRecently(habit);
        clearTimeout(habit.id);
        return;
      }

      // Prevent event if habit checked less then 'bigDelay' minutes ago.
      if (habit.isBlocked) {
        return;
      }

      // Update the habit in the view.
      habit.data.push({ datetime: moment(), value: 0.5 });
      habit.isCompletedRecently = true;

      // Submit trigger
      startSubmitHabitTimer(habit, { datetime: moment(), value: 1 });

      // Update stored Goal data
      $sessionStorage['goal-' + vm.goalDataCopy.id] = vm.goalDataCopy;
    }

    function triggerHabitRequest(habit, data, preventUnlockTimer) {
      var _goal = angular.copy(vm.goalDataCopy);

      // Get the associated habit from the copy
      var _habit = _goal.sections.find(function (h) {
        return habit.id === h.id;
      });

      // Set the submission
      _habit.data.push(data);
      _habit.widgets[0].response = 1;
      goalSvc.triggerHabit(_goal);

      // Update flags for view
      habit.isBlocked = true;
      delete habit.isCompletedRecently;

      // Update stored Goal data
      $sessionStorage['goal-' + vm.goalDataCopy.id] = vm.goalDataCopy;

      // Start ''Unlock Habit' timer if it's not on destroy event.
      if (!preventUnlockTimer) {
        startUnlockHabitTimer(vm.goalDataCopy.id, habit);
      }

      // Clear timeout for current habit
      clearTimeout(habit.id);
    }

    function startSubmitHabitTimer(habit, data) {
      vm.timeouts[habit.id] = {
        habit: habit,
        data: data,
        timeout: $timeout(function () {
          triggerHabitRequest(habit, data);
        }, getTimeoutDelay(habit, vm.smallDelay))
      };

      $sessionStorage['goal-timeouts-' + vm.goalDataCopy.id] = vm.timeouts;
    }

    function startUnlockHabitTimer(goalId, habit) {
      vm.unlockHabitTimer[habit.id] = $timeout(function () {
        delete habit.isBlocked;
        delete vm.unlockHabitTimer[habit.id];

        $sessionStorage['goal-' + goalId] = vm.goalDataCopy;
      }, getTimeoutDelay(habit, vm.bigDelay));
    }

    function removeCompletedRecently(habit) {
      var index = habit.data.indexOf(_.last(habit.data));
      if (index > -1) {
        habit.data.splice(index, 1);
        delete habit.isBlocked;
        delete habit.isCompletedRecently;
      }
    }

    function isCompletedRecently(habit, minutes) {
      if (habit.data && habit.data.length >= 1) {
        return moment().diff(_.last(habit.data).datetime, 'minutes') <= minutes;
      } else {
        return false;
      }
    }

    function clearTimeout(habitId) {
      if (vm.timeouts[habitId].timeout) {
        $timeout.cancel(vm.timeouts[habitId].timeout);
        delete vm.timeouts[habitId];
      }
    }

    function getTimeoutDelay(habit, minutesDelay) {
      if (habit.isBlocked || habit.isCompletedRecently) {
        var different = moment().diff(_.last(habit.data).datetime, 'milliseconds');
        return minutesDelay * 60000 - different;
      }
    }

    function getCompletedTime(habit) {
      if (habit.isBlocked || habit.isCompletedRecently) {
        var different = moment().diff(_.last(habit.data).datetime, 'minutes');
        return moment().add(vm.bigDelay + 0.5 - different, 'minutes').startOf('minutes').fromNow();
      }
    }

    function getCompletedDate(data) {
      return data && data.length > 0 ? $filter('mostRecentResponseDate')(data).fromNow() : 'Never';
    }

    function getHabitLabel(habit) {
      if (habit.isCompletedRecently) {
        var justCompleteKey = 'vnext.tools.goals.justCompletedHabit';
        var undoKey = 'vnext.tools.goals.undoCompletion';
        return $translate.instant(justCompleteKey) === justCompleteKey && $translate.instant(undoKey) === undoKey ? 'You\'ve just completed a habit ' + habit.name + '. If you want to undo this action, click the circle again.' : $translate.instant(justCompleteKey) + ' ' + habit.name + '. ' + $translate.instant(undoKey);
      }
      if (habit.isBlocked) {
        var _translateId = 'vnext.tools.goals.justCompletedHabit';
        return $translate.instant(_translateId) === _translateId ? 'You\'ve just completed a habit ' + habit.name : $translate.instant(_translateId) + ' ' + habit.name;
      }
      var translateId = 'vnext.tools.goals.completeHabit';
      return $translate.instant(translateId) === translateId ? 'Complete a habit ' + habit.name : $translate.instant(translateId) + ' ' + habit.name;
    }

    function openEditHabitsModal() {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'goals/templates/edit-habits-list-modal.html',
        controller: 'EditHabitsListCtrl',
        inputs: {
          habits: vm.goalDataCopy.sections
        }
      });
    }

    function openEditGoalModal(stepToStartAt, goal) {
      $log.debug('card openEditGoalModal called');
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'goals/templates/create-new-goal-modal.html',
        controller: 'EditGoalCtrl',
        inputs: {
          step: stepToStartAt,
          goal: goal,
          editMode: true
        }
      });
    }
  }
})();